import { render, staticRenderFns } from "./complete-tab.vue?vue&type=template&id=20630948"
import script from "./complete-tab.vue?vue&type=script&lang=js"
export * from "./complete-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports